import api from './api';
import { ApiResponse, DisplayLogic } from '../types';

export const displayLogicService = {
  setDisplayLogic: async (
    questionnaireId: number,
    questionId: number,
    logic: DisplayLogic
  ): Promise<DisplayLogic> => {
    const response = await api.put<ApiResponse<DisplayLogic>>(
      `/admin/questionnaires/${questionnaireId}/questions/${questionId}/display-logic`,
      logic
    );
    return response.data.data;
  },

  getDisplayLogic: async (
    questionnaireId: number,
    questionId: number
  ): Promise<DisplayLogic | null> => {
    try {
      const response = await api.get<ApiResponse<DisplayLogic>>(
        `/admin/questionnaires/${questionnaireId}/questions/${questionId}/display-logic`
      );
      return response.data.data;
    } catch (error) {
      return null;
    }
  },

  deleteDisplayLogic: async (questionnaireId: number, questionId: number): Promise<void> => {
    await api.delete(`/admin/questionnaires/${questionnaireId}/questions/${questionId}/display-logic`);
  },
};
